import InterestNonWorkingDays from "@/models/Shared/NonWorkingDays";
import PeriodType from "@/models/Shared/PeriodType";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import ScheduleDueDatesType from "@/models/Shared/ScheduleDueDatesType";
import ShortMonthHandlingType from "@/models/Shared/ShortMonthHandlingType";

export default class LendingScheduleSettings extends BaseProductSettings {
    dueDatesType: ScheduleDueDatesType = ScheduleDueDatesType.Interval;
    paymentIntervalPeriodType: PeriodType = PeriodType.Day;
    paymentIntervalPeriodValue: number = 1;
    fixedDaysOfMonth: number[] = [];
    shortMonthHandlingType: ShortMonthHandlingType = ShortMonthHandlingType.FirstDayOfMonth;
    numberOfInstallments: number = 10;
    numberOfInstallmentsMinimum: number = 1;
    numberOfInstallmentsMaximum: number = 12;
    firstDueDateOffsetPeriodType: PeriodType = PeriodType.Day;
    firstDueDateOffsetPeriodValue: number = 1;
    firstDueDateOffsetPeriodValueMinimum: number = 0;
    firstDueDateOffsetPeriodValueMaximum: number = 0;
    gracePeriodType: PeriodType = PeriodType.Day;
    gracePeriodValue: number = 10;
    nonWorkingDaysType: InterestNonWorkingDays = InterestNonWorkingDays.NextWorkingDay;
    adjustPaymentDatesEnabled: boolean = false;
    adjustPrincipalPaymentScheduleEnabled: boolean = false;
    adjustInterestPaymentScheduleEnabled: boolean = false;
    adjustFeePaymentScheduleEnabled: boolean = false;
    adjustPenaltyPaymentScheduleEnabled: boolean = false;
    paymentHolidaysEnabled: boolean = false;
}